import { PlannedActivityClient } from "../services/ohl.virtualCenter.api";
import moment from 'moment';

const apiClient = new PlannedActivityClient(process.env.REACT_APP_PUBLIC_API);

class PlannedActivitiesProvider {

    /* getOne = (resource, params) => {
        return apiClient.plannedActivityGet(params.id).then((data) => {
            return { data }
        });
    } */

    getList = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        
        return apiClient.list({
            pageNumber: page,
            pageSize: perPage,
            orderField: field,
            orderAsc: order === 'ASC',
            ...params.filter
        }).then((data) => {
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }


    initialProcess = (data) => {
        if (data.startDate) {
            data.startDate = moment(data.startDate).format('yyyy-MM-DDTHH:mm:ss')
        }

        if (data.endDate) {
            data.endDate = moment(data.endDate).format('yyyy-MM-DDTHH:mm:ss')
        }

        return apiClient.initialProcess(data).then((data) => {
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }
/* 
    create = (resource, params) => {
        return apiClient.plannedActivity(params.data).then((data) => ({
            data
        }));
    } */

};

export default new PlannedActivitiesProvider();